import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/wild-pitch
// @see https://baseball.fandom.com/wiki/Wild_pitch
// A pitcher is charged with a wild pitch when his pitch is so errant that the catcher is unable to control it and, as a result, baserunner(s) advance. (This is an important stipulation. No matter how poor the pitch, a pitcher is only charged with a WP if at least one runner moves up a base, and he cannot be charged with a wild pitch if no one is on base -- unless it allows the batter to reach base on a third strike.)
// When (a) first base is unoccupied and/or (b) there are two outs, the catcher must catch the third strike in order to retire the batter; if a wild pitch occurs on such a third strike, the pitcher is credited with a strikeout, but the batter is not retired—he may attempt to advance to first base and must be tagged with the ball or forced at first in order to effect an out.
const classifiesAsWildPitch = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.WildPitch.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsWildPitch;